import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const About = () =>
  <div>
    <div class="close"><Link to="/"><img src="https://icon.now.sh/x" /></Link></div>

   
    <div class="aboutPage">
    <h4>How it Works?</h4>
    <div className="hiw col-6"><b>Step 1</b> : Select Service. </div>
          <div className="hiw col-6"><b>Step 2</b> : Enter Stream Amount.</div>
   
          <br />
this is an <a target="_blank" href="https://auxcorde.com?ref=streamcalculator">auxcorde</a> product, built by<br /> <a target="_blank" href="https://www.instagram.com/dougieplaylist/">👂</a> + <a target="_blank" href="https://twitter.com/fodafarm">🐖</a> 
<p><i>*</i>earnings are not exact, they are just estimates</p>
</div>
  </div>

export default About



// WEBPACK FOOTER //
// ./src/About.js